
/*
import './App.css';
import SpeedTypingGame from './typing/SpeedTyping';

function App() {
  return (
    <div className="App">
      <SpeedTypingGame />
    </div>
  );
}

export default App;*/
import sketchifyImg from "./assets/Sketchify.png";
import linkoImg from "./assets/Linko.png";
import fashionImg from "./assets/Fashion.png";

import styled from "styled-components";
import { FaGithub, FaLinkedin, FaBars, FaTimes } from "react-icons/fa";
import { useState } from "react";

/* ================= STYLES ================= */

const Page = styled.div`
  background: #0d0d0d;
  color: white;
  font-family: "Poppins", sans-serif;
`;

/* NAVBAR */

const Navbar = styled.nav`
  position: fixed;
  width: 100%;
  background: rgba(0,0,0,0.8);
  backdrop-filter: blur(10px);
  padding: 15px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
`;

const Logo = styled.h1`
  font-size: 1.5rem;
`;

const MenuIcon = styled.div`
  display: none;
  font-size: 1.5rem;
  cursor: pointer;

  @media(max-width:768px){
    display: block;
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 25px;

  a {
    cursor: pointer;
    transition: 0.3s;

    &:hover {
      color: #00bfff;
    }
  }

  @media(max-width:768px){
    position: absolute;
    top: 70px;
    right: ${({open}) => open ? "0" : "-100%"};
    background: #111;
    flex-direction: column;
    width: 200px;
    padding: 20px;
    transition: 0.3s;
  }
`;

/* SECTIONS */

const Section = styled.section`
  padding: 100px 20px;
  text-align: center;

  @media(max-width:768px){
    padding: 80px 15px;
  }
`;

const Hero = styled(Section)`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Title = styled.h2`
  font-size: 2.8rem;
  margin-bottom: 20px;

  @media(max-width:768px){
    font-size: 2rem;
  }
`;

const Subtitle = styled.p`
  color: #aaa;
  font-size: 1.2rem;
  max-width: 700px;
  margin: auto;

  @media(max-width:768px){
    font-size: 1rem;
  }
`;

const Button = styled.a`
  margin-top: 25px;
  padding: 12px 25px;
  background: #00bfff;
  color: white;
  border-radius: 10px;
  cursor: pointer;
  display: inline-block;

  &:hover {
    background: #0099cc;
  }
`;

/* SKILLS */

const SkillsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  gap: 20px;
  max-width: 900px;
  margin: auto;
`;

const Skill = styled.div`
  background: #1a1a1a;
  padding: 15px;
  border-radius: 10px;

  &:hover {
    transform: translateY(-5px);
  }
`;

/* PROJECTS */

const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 25px;
  max-width: 1100px;
  margin: auto;
`;

const Card = styled.div`
  background: #1a1a1a;
  padding: 20px;
  border-radius: 15px;

  &:hover {
    transform: scale(1.03);
  }
`;

const ProjectImage = styled.img`
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 10px;
  margin-bottom: 15px;
  cursor: pointer;
`;

/* BADGES */

const Tech = styled.div`
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const Badge = styled.span`
  background: #00bfff;
  padding: 5px 10px;
  border-radius: 8px;
  font-size: 0.8rem;
`;

/* MODAL */

const Overlay = styled.div`
  position: fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background: rgba(0,0,0,0.8);
  display:flex;
  justify-content:center;
  align-items:center;
  z-index:2000;
`;

const Modal = styled.div`
  background:#111;
  padding:25px;
  border-radius:15px;
  max-width:700px;
  width:90%;
  position:relative;
`;

const CloseBtn = styled.div`
  position:absolute;
  top:15px;
  right:15px;
  cursor:pointer;
  font-size:1.5rem;
`;

const ModalImage = styled.img`
  width:100%;
  border-radius:10px;
  margin-bottom:15px;
`;

const ModalTitle = styled.h3`
  margin-bottom:10px;
`;

const ModalText = styled.p`
  color:#ccc;
`;

/* CONTACT */

const ContactBox = styled.div`
  margin-top: 20px;
`;

const Footer = styled.footer`
  padding: 20px;
  background: #111;
  text-align: center;
`;

const Icons = styled.div`
  margin-top: 10px;
  font-size: 1.5rem;

  a {
    margin: 0 10px;
  }
`;

/* ================= DATA ================= */

const skills = [
  "React",
  "Next.js",
  "Flutter",
  "Node.js",
  "Express.js",
  "MongoDB",
  "PostgreSQL",
  "Django",
  "TypeScript",
  "TailwindCSS",
  "Git"
];

const projects = [
  {
    title: "Linkonomy",
    description:
      "Job matching platform connecting job seekers with opportunities.",
    tech: ["Next.js", "PostgreSQL", "Express","TypeScript"],
    image: linkoImg,
    details:
      "Linkonomy helps users discover jobs based on their skills. Includes authentication, job posting, and filtering system."
  },
  {
    title: "Fashion Forge",
    description:
      "Full-stack MERN e-commerce platform.",
    tech: ["React","Express", "MongoDB", "Redux"],
    image: fashionImg,
    details:
      "E-commerce website with admin dashboard, product management, and payment features."
  },
  {
    title: "Sketchify",
    description:
      "AI image transformation platform.",
    tech: ["React", "Django", "PostgreSQL","TypeScript"],
    image: sketchifyImg,
    details:
      "Transforms photos into artistic sketches using deep learning CNN models."
  }
];

/* ================= APP ================= */

function App() {

  const [open, setOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  return (

    <Page>

      {/* NAVBAR */}

      <Navbar>

        <Logo>Kritan.dev</Logo>

        <MenuIcon onClick={() => setOpen(!open)}>
          <FaBars />
        </MenuIcon>

        <NavLinks open={open}>
          <a href="#about">About</a>
          <a href="#skills">Skills</a>
          <a href="#projects">Projects</a>
          <a href="#contact">Contact</a>
        </NavLinks>

      </Navbar>

      {/* HERO */}

      <Hero>

        <Title>
          Hi, I'm Kritan Shahi 👋
        </Title>

        <Subtitle>
          Full-Stack Developer | MERN | Next.js | Flutter | AI Developer
        </Subtitle>

        <Button href="#projects">
          View Projects
        </Button>

      </Hero>

      {/* ABOUT */}

      <Section id="about">

        <Title>About Me</Title>

        <Subtitle>
          I am a BCA undergraduate passionate about building 
          scalable web and mobile applications.
        </Subtitle>

      </Section>

      {/* SKILLS */}

      <Section id="skills">

        <Title>Skills</Title>

        <SkillsGrid>

          {skills.map((skill, i) => (
            <Skill key={i}>
              {skill}
            </Skill>
          ))}

        </SkillsGrid>

      </Section>

      {/* PROJECTS */}

      <Section id="projects">

        <Title>Projects</Title>

        <ProjectsGrid>

          {projects.map((project, i) => (

            <Card key={i}>

              <ProjectImage
                src={project.image}
                alt={project.title}
                onClick={() => setSelectedProject(project)}
              />

              <h3>{project.title}</h3>

              <p>{project.description}</p>

              <Tech>

                {project.tech.map((t, i) => (
                  <Badge key={i}>{t}</Badge>
                ))}

              </Tech>

            </Card>

          ))}

        </ProjectsGrid>

      </Section>

      {/* MODAL */}

      {selectedProject && (

        <Overlay onClick={() => setSelectedProject(null)}>

          <Modal onClick={(e) => e.stopPropagation()}>

            <CloseBtn
              onClick={() => setSelectedProject(null)}
            >
              <FaTimes />
            </CloseBtn>

            <ModalImage
              src={selectedProject.image}
            />

            <ModalTitle>
              {selectedProject.title}
            </ModalTitle>

            <ModalText>
              {selectedProject.details}
            </ModalText>

            <Tech>

              {selectedProject.tech.map((t,i)=>(
                <Badge key={i}>{t}</Badge>
              ))}

            </Tech>

          </Modal>

        </Overlay>

      )}

      {/* CONTACT */}

      <Section id="contact">

        <Title>Contact</Title>

        <ContactBox>

          <p>Email: shahikritan11@gmail.com</p>

          <Icons>

            <a href="https://github.com/KritanShahi">
              <FaGithub />
            </a>

            <a href="https://www.linkedin.com/in/kritan-shahi-2581202a4/">
              <FaLinkedin />
            </a>

          </Icons>

        </ContactBox>

      </Section>

      <Footer>
        © 2026 Kritan Shahi — All Rights Reserved
      </Footer>

    </Page>

  );
}

export default App;